import { useRef, useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import userRoles from "../../../../../constants/userRoles";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { postDeleteUser } from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { removeUserFromUsers } from "../../../../../redux/reducer/admin.reducer";
import { adminRoutes } from "../../../../../router/routesConstants";
import usePermissions from "../../../../../router/usePermissions";

function UsersActionButton({ itemId, crudData, tableContext }: any) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();
  const [isDeleting, setIsDeleting] = useState(false);
  const isSubmitting = useRef(false);

  const canAdministrateRolesAndNodes = isAuthorized(
    userRoles.ADMINISTRATE_ROLES_AND_NODES,
  );

  const handleDeleteUser = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsDeleting(true);

    try {
      const resultAction = await dispatch(postDeleteUser({ userId: itemId }));

      if (
        checkEndpointStatus(resultAction, postDeleteUser) ===
          endpointStatus.fulfilled &&
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage
      ) {
        dispatch(removeUserFromUsers(itemId));
      }
    } finally {
      isSubmitting.current = false;
      setIsDeleting(false);
    }
  };

  const userName = `${crudData.nume} ${crudData.prenume}`;

  return (
    <ActionMenu
      title={userName}
      ariaLabel={`Actiuni pentru utilizatorul ${userName}`}
      items={[
        {
          id: "edit-user",
          label: "Editeaza utilizator",
          section: "manage",
          icon: "EDIT",
          tooltip: "Modifica datele acestui utilizator.",
          navigate: `/${adminRoutes.users}/${adminRoutes.editUser}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`,
        },
        {
          id: "web-roles",
          label: "Roluri web",
          section: "manage",
          icon: "WEB_ROLES",
          tooltip: "Configureaza rolurile utilizatorului in aplicatia web.",
          navigate: `/${adminRoutes.users}/${adminRoutes.adminUserWebRoles}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`,
        },
        {
          id: "mobile-roles",
          label: "Roluri palm",
          section: "manage",
          icon: "PALM_ROLES",
          tooltip: "Configureaza rolurile utilizatorului in aplicatia mobila.",
          navigate: `/${adminRoutes.users}/${adminRoutes.adminUserMobileRoles}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`,
        },
        {
          id: "roles-and-nodes",
          label: "Functii si noduri",
          section: "manage",
          icon: "ROLES_AND_FUNCTIONS",
          tooltip:
            "Configureaza functiile si nodurile asociate utilizatorului.",
          hidden: !canAdministrateRolesAndNodes,
          navigate: `/${adminRoutes.users}/${adminRoutes.rolesAndNodes}?userId=${itemId}&userName=${crudData.username}`,
        },
        {
          id: "delete-user",
          label: "Stergere",
          section: "danger",
          icon: "DELETE",
          color: "error",
          loading: isDeleting,
          tooltip: "Sterge utilizatorul dupa confirmare.",
          withConfirmationModal: {
            modalTitle: "Stergere utilizator",
            modalSubtitle: `Doriti sa stergeti utilizatorul: ${crudData.nume} ${crudData.prenume}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDeleteUser,
            modalRightButtonText: "Sterge",
            modalRightButtonColor: "error",
          },
        },
      ]}
    />
  );
}

export default UsersActionButton;
